import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Logo from "../../assets/LogoPrincipal.png";
import Styles from "./EmailVerification.module.css";
import api from "../../utils/axios/api";

const EmailVerification = () => {
    const [success, setSuccess] = useState<boolean | null>(null)
    useEffect(() => {
        async function verifyUser() {
            const queryParams = new URLSearchParams(window.location.search);

            const token = queryParams.get("token");

            if(!token) {
                setSuccess(false)
                return
            }
            try {
                await api.post(`/user/confirm/${token}`)
                setSuccess(true)
            } catch (error) {
                console.log(error)
                setSuccess(false)
            }
        };

        verifyUser()
    }, []);

    useTranslation();

    return (
        <div>
            <div className={Styles.container}>
                <div className={Styles.emailHead}>
                    <img src={Logo} />
                </div>
                <div className={Styles.emailBody}>
                    <img src={Logo} />
                </div>
                <div className={Styles.emailFooter}>
                    {success === null ? undefined : success ? <p className={Styles.emailFinalizado}>{"Seu email foi verificado com sucesso!"}</p>
                        : <p className={Styles.emailFinalizado}>{"Erro ao verificar e-mail!"}</p>}
                    <p className={Styles.Tela}>
                        <br />
                        <Link to={"/login"}>{"Realizar login"}</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;
